export function documentFromHTML(html) {
  return document.createRange().createContextualFragment(html);
}
